import { useEffect, useState } from "react";

/**
 * Live elapsed timer that ticks every second. Pass `startedAt` (ISO string or Date).
 * If `stoppedAt` is provided, renders the frozen interval.
 */
export function LiveTimer({ startedAt, stoppedAt, className = "", testid }) {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        if (stoppedAt) return;
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, [stoppedAt]);

    if (!startedAt) return null;
    const start = new Date(startedAt).getTime();
    const end = stoppedAt ? new Date(stoppedAt).getTime() : now;
    const ms = Math.max(0, end - start);
    const sec = Math.floor(ms / 1000);
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    const text = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    return (
        <span
            data-testid={testid || "live-timer"}
            className={`font-mono tabular-nums tracking-tight ${className}`}
        >
            {text}
        </span>
    );
}
